const DEFAULT_TIMEOUT_MS = 15000;

export const apiFetch = async (url, options = {}, errorHandler, timeoutMs = DEFAULT_TIMEOUT_MS) => {
    const controller = new AbortController();

    // Flag pour distinguer un timeout réel d'un abort initié par le caller (cleanup)
    let timedOut = false;
    const timeoutId = setTimeout(() => {
        timedOut = true;
        controller.abort();
    }, timeoutMs);

    // Si le caller fournit un signal (cleanup useEffect), on s'y abonne
    const callerSignal = options.signal;
    if (callerSignal) {
        // Si déjà annulé avant même de commencer
        if (callerSignal.aborted) {
            clearTimeout(timeoutId);
            const abortError = new DOMException('Aborted', 'AbortError');
            throw abortError;
        }
        callerSignal.addEventListener('abort', () => controller.abort(), { once: true });
    }

    try {
        const response = await fetch(url, { ...options, signal: controller.signal });
        clearTimeout(timeoutId);

        const contentType = response.headers.get('content-type') || '';

        const parseBody = async () => {
            if (contentType.includes('application/json')) {
                return await response.json();
            }
            return await response.text();
        };

        const body = await parseBody();

        if (!response.ok) {
            const error = typeof body === 'string'
                ? { message: body || response.statusText }
                : (body || { message: response.statusText });
            if (errorHandler) errorHandler(error, response);
            throw error;
        }

        return body;
    } catch (error) {
        clearTimeout(timeoutId);

        if (error.name === 'AbortError') {
            if (timedOut) {
                // Timeout réel — notifier l'utilisateur
                const timeoutError = { message: 'La requête a expiré. Veuillez réessayer.' };
                if (errorHandler) errorHandler(timeoutError);
                throw timeoutError;
            }
            // Abort initié par cleanup useEffect — silencieux, rethrow tel quel
            throw error;
        }

        if (errorHandler && error.message === 'Failed to fetch') {
            errorHandler({ message: 'Erreur réseau. Vérifiez votre connexion.' });
        }
        throw error;
    }
};
